/**
 * Estados possíveis do serviço do ACS.
 */
export enum AcsServiceStatus {
    ONLINE, REFRESHING, UNAUTHORIZED, OFFLINE
}
